var _circle, _circle2, _rect, _path, _path2, _path3, _path4, _g, _g2, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31.5,
    fill: "white",
    stroke: "#FCD1C1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 28,
    fill: "#FCD1C1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F46530"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.5003 49.3867V51.2933L50.8269 51.06C50.4869 50.94 50.2803 50.8267 50.2803 50.2467C50.2803 49.7733 50.6336 49.3867 51.0669 49.3867H51.5003Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.72 53.7533C53.72 54.2267 53.3667 54.6133 52.9333 54.6133H52.5V52.7067L53.1733 52.94C53.5133 53.06 53.72 53.1733 53.72 53.7533Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.793 45.3333H49.2063C46.7797 45.3333 45.333 46.78 45.333 49.2066V54.7933C45.333 57.22 46.7797 58.6666 49.2063 58.6666H54.793C57.2197 58.6666 58.6663 57.22 58.6663 54.7933V49.2066C58.6663 46.78 57.2197 45.3333 54.793 45.3333ZM53.5063 52C54.0263 52.18 54.7197 52.56 54.7197 53.7533C54.7197 54.78 53.9197 55.6133 52.933 55.6133H52.4997V56C52.4997 56.2733 52.273 56.5 51.9997 56.5C51.7263 56.5 51.4997 56.2733 51.4997 56V55.6133H51.2597C50.1663 55.6133 49.2797 54.6866 49.2797 53.5533C49.2797 53.28 49.4997 53.0533 49.7797 53.0533C50.053 53.0533 50.2797 53.28 50.2797 53.5533C50.2797 54.14 50.7197 54.6133 51.2597 54.6133H51.4997V52.3533L50.493 52C49.973 51.82 49.2797 51.44 49.2797 50.2466C49.2797 49.22 50.0797 48.3866 51.0663 48.3866H51.4997V48C51.4997 47.7266 51.7263 47.5 51.9997 47.5C52.273 47.5 52.4997 47.7266 52.4997 48V48.3866H52.7397C53.833 48.3866 54.7197 49.3133 54.7197 50.4466C54.7197 50.72 54.4997 50.9466 54.2197 50.9466C53.9463 50.9466 53.7197 50.72 53.7197 50.4466C53.7197 49.86 53.2797 49.3866 52.7397 49.3866H52.4997V51.6466L53.5063 52Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0003 44L45.3337 34.6667H40.0137L40.0003 20H24.0003V34.6667H18.667L32.0003 44Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_129_8423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 34.6667L36 26.6667",
    stroke: "#F46530",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_129_8423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6667 28C29.0349 28 29.3333 27.7015 29.3333 27.3334C29.3333 26.9652 29.0349 26.6667 28.6667 26.6667C28.2985 26.6667 28 26.9652 28 27.3334C28 27.7015 28.2985 28 28.6667 28Z",
    fill: "#F46530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6667 28C29.0349 28 29.3333 27.7015 29.3333 27.3334C29.3333 26.9652 29.0349 26.6667 28.6667 26.6667C28.2985 26.6667 28 26.9652 28 27.3334C28 27.7015 28.2985 28 28.6667 28Z",
    stroke: "#F46530",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3337 34.6666C35.7018 34.6666 36.0003 34.3682 36.0003 34C36.0003 33.6318 35.7018 33.3333 35.3337 33.3333C34.9655 33.3333 34.667 33.6318 34.667 34C34.667 34.3682 34.9655 34.6666 35.3337 34.6666Z",
    fill: "#F46530",
    stroke: "#F46530",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_129_8423",
    x: 25,
    y: 23.6667,
    width: 18,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.439216 0 0 0 0 0.396078 0 0 0 0 0.941176 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_129_8423"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_129_8423",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_129_8423",
    x: 25,
    y: 23.6667,
    width: 11.333,
    height: 11.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.439216 0 0 0 0 0.396078 0 0 0 0 0.941176 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_129_8423"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_129_8423",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowest);
export default __webpack_public_path__ + "static/media/lowest.538198aa37dc36d9c3432f9daa6941ae.svg";
export { ForwardRef as ReactComponent };